import type { FaireProductEntity } from "../../entity_types/product";

export const p_bkfpqv4jeh: FaireProductEntity = {
  token: "p_bkfpqv4jeh",
  type: "product",
  name: "Gel Pens 12 Glitter Colors",
  brandName: "KINGART",
  imageUrl:
    "https://cdn.faire.com/fastly/35fa8380d6169af67281e651c67db37b206e0c8af27ea82b69f2d869019de2fe.jpeg",
  priceDollars: 6.49,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/19b01e18963a88903e33691da2d2e0c05136308d7a8b98ca0cef23a1054133d7.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
